import React from 'react'
import { connect } from 'react-redux'
import { Button } from 'react-weui'
import { browserHistory } from 'react-router'
import { Page, CustomerServiceQrcode, WKVisible } from '../components'
import alertImg from '../images/alert.png'
import config from '../config'
import lectureErrorImg from '../images/lecture-error.png'
import '../css/page/LectureErrorPage.css'


class LectureErrorPage extends React.Component {
    componentDidMount () {
        this.props.dispatch({
            type: 'CUSTOMER_QRCODE_INIT',
            payload: {
                api: '/api/board/service/allocate',
                title: '联系客服',
                des: '长按扫码添加客服；添加时，请备注"客服指引"',
            },
        })
    }
    handleClickService () {
        this.props.dispatch({
            type: 'CUSTOMER_QRCODE_SHOW',
        })
    }
    handleClickBack () {
        browserHistory.replace('/')
    }
    componentWillUnmount () {
        this.props.dispatch({
            type: 'CUSTOMER_QRCODE_HIDE',
        })
    }
    getPageTypeName (pageType) {
        switch (pageType) {
            case 'lecture':
                return '课程'
            case 'channel':
                return '专栏'
            case 'liveroom':
                return '店铺'
            case 'schedule':
                return '打卡活动'
            default:
                return '页面'
        }
    }
    render() {
        const type = this.props.params.type
        const pageTypeName = this.getPageTypeName(this.props.params.pageType)
        return (
            <Page>
                <div className="wk-inner-page lecture-error-page">
                    <div className="error-wrap">
                        <div className="error-icon">
                            <img src={lectureErrorImg} />
                        </div>
                        <WKVisible className='text' create={type === 'delete'}>
                            <p>该{pageTypeName}可能存在安全风险，暂无法进行访问</p>
                            {/*<p>您访问的{pageTypeName}已被删除</p>*/}
                        </WKVisible>
                        <WKVisible className='text' create={type === 'illegal'}>
                            <p style={{marginBottom: '15px'}}>该{pageTypeName}可能存在安全风险，暂无法进行访问</p>
                            {/*<p className='text-minor'>*/}
                                {/*接相关投诉，此内容违反“互联网直播服务管理规定“，查看 <a href={`${config.MAIN_URL}/board/page/164`}>详细内容</a>*/}
                            {/*</p>*/}
                        </WKVisible>
                        <Button onClick={() => this.handleClickBack()}>回到首页</Button>
                    </div>
                    <a className='bottom-service' href="/activity/servicepage/">客服指引</a>
                </div>
                { this.props.customerservice.QrcodeShow && <CustomerServiceQrcode /> }
            </Page>
        )
    }
}

export default connect(state => ({
    customerservice: state.customerservice,
}))(LectureErrorPage)


// WEBPACK FOOTER //
// ./src/pages/LectureErrorPage.js